import { api } from '@/lib/api/axios';
import type {
  CreateWalkInQueueRequestDto,
  CreateWalkInQueueResponseDto,
  ProfileWalkInsResponse,
  ProfileWalkInDto,
} from '@/types/dto/walk-in.dto';

export const WalkInService = {
  create: async (payload: CreateWalkInQueueRequestDto): Promise<CreateWalkInQueueResponseDto> => {
    const { data } = await api.post<CreateWalkInQueueResponseDto>('/walk-in-queue/entries', payload);

    return data;
  },
  active: async (): Promise<ProfileWalkInDto | null> => {
    const { data } = await api.get<ProfileWalkInDto | null>('/walk-in-queue/entries/me');
    return data;
  },
  list: async (): Promise<ProfileWalkInsResponse> => {
    const data = await WalkInService.active();
    return data ? [data] : [];
  },
  updateServices: async (entryId: string, serviceIds: string[]): Promise<ProfileWalkInDto> => {
    const { data } = await api.patch<ProfileWalkInDto>(`/walk-in-queue/entries/${entryId}/services`, { serviceIds });
    return data;
  },
  cancel: async (walkInId: string): Promise<void> => {
    await api.patch(`/walk-in-queue/entries/${walkInId}/cancel`);
  },
};
